export default {
    /**
     * 缓存耗时计算
     * @param fn 纯函数
     */
    cached(fn) {
        const cache = Object.create(null)
        return function cachedFn(str) {
            const hit = cache[str]
            return hit || (cache[str] = fn(str))
        }
    },
    checkDataType(type, val) {
        ![undefined, null].includes(val) && val.constructor === type;
    },
    isNil(str) {
        return str === undefined || str === null
    },
    isEmptyString(str) {
        return this.isNil(str) || str === '' || !str
    },
    isNumber(num) {
        return !isNaN(parseFloat(num)) && isFinite(num);
    },
    isObject(obj) {
        return !this.isNil(obj) && typeof obj == 'object' && toString.call(obj) != "[object Array]"
    },
    isEmptyObject(obj) {
        return isObject(obj) ? Object.keys(obj).length : 0;
    },
    isValidJSON(str) {
        try {
            JSON.parse(str)
            return true
        } catch (e) {
            return false
        }
    },
    trimStr(str, type) {
        switch (type) {
            case 1:
                return str.replace(/\s+/g, "");
            case 2:
                return str.replace(/\s*$/g, "");
            case 3:
                return str.replace(/^\s*/g, "");
            case 4:
                return str.replace(/(^\s*)|(\s*$)/g, "");
            default:
                return str;
        }
    },
    mergeObject(a, b) {
        let res = {};
        Object.keys({ ...a, ...b }).map(key => {
            res[key] = a[key] || b[key];
        });
        return res;
    },
    unary(...fn) {
        (...args) => fn(...args);
    },
    when(pred, whenTrue) {
        (x) => (pred(x) ? whenTrue(x) : x)
    },
    call(key, ...args) {
        context => context[key](...args);
    },
    uniq(arr, key = 'id') {
        let obj = {};
        return arr.reduce((item, next) => {
            obj[next[key]] ? "" : (obj[next[key]] = true && item.push(next));
            return item;
        }, []);
    },
    debounce(func, wait, immediate) {
        
        let timeout, args, context, timestamp, result

        const later = function () {
            // 据上一次触发时间间隔
            const last = +new Date() - timestamp

            // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
            if (last < wait && last > 0) {
                timeout = setTimeout(later, wait - last)
            } else {
                timeout = null
                // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
                if (!immediate) {
                    result = func.apply(context, args)
                    if (!timeout) context = args = null
                }
            }
        }

        return function (...args) {
            context = this
            timestamp = +new Date()
            const callNow = immediate && !timeout
            // 如果延时不存在，重新设定延时
            if (!timeout) timeout = setTimeout(later, wait)
            if (callNow) {
                result = func.apply(context, args)
                context = args = null
            }

            return result
        }
    }
}



// WEBPACK FOOTER //
// ./src/assets/plugin/prototypes/modules/utils.js